export const FLOW = {
  DISCLAIMER: "disclaimer",
  ACTIVATE_APP: "activate-app",
  USER: "user",
};
